import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  // viene de RxJS
  inProgress = new Subject<boolean>();

  constructor(private spinner: NgxSpinnerService) {}

  // mostrar el spining
  show() {
    this.inProgress.next(true);
    this.spinner.show();
  }

  // ocultar el spining
  hide() {
    this.inProgress.next(false);
    this.spinner.hide();
  }
}
